module.exports = __webpack_public_path__ + "img/img_example_2.7a6c5b0f.png";